<div class="policy-notification" *ngIf="showPolicyNotification">
  <div class="policy-container">
    <h3 class="policy-title">Публичная оферта и Политика конфиденциальности</h3>
    <p class="policy-content">
      Нажимая "Согласен", вы подтверждаете, что ознакомлены с условиями публичной оферты и политики конфиденциальности, а также соглашаетесь на обработку ваших персональных данных в соответствии с законодательством Республики Казахстан.
    </p>
    <div class="policy-scrollable">
      <h6 class="policy-section-title">Публичная оферта</h6>
      <ul class="policy-points">
        <li><strong>Общие положения:</strong></li>
        <ul>
          <li>1.1. Настоящая оферта регулирует порядок предоставления услуг по продаже и доставке готовой продукции.</li>
          <li>1.2. Факт оформления заказа через сайт, мессенджеры или по телефону подтверждает акцепт Клиентом настоящей оферты и означает согласие с ее условиями.</li>
        </ul>
        <li><strong>Предмет договора:</strong></li>
        <ul>
          <li>2.1. Компания предоставляет услуги по продаже и доставке готовой продукции.</li>
          <li>2.2. Клиент обязуется оплатить заказ в соответствии с условиями настоящей оферты.</li>
        </ul>
        <li><strong>Оформление заказа:</strong></li>
        <ul>
          <li>3.1. Заказ осуществляется через официальный сайт, мессенджеры или по телефону, указанному на платформе Компании.</li>
          <li>3.2. Клиент обязуется предоставить актуальные контактные данные для своевременной доставки заказа.</li>
        </ul>
        <li><strong>Условия оплаты:</strong></li>
        <ul>
          <li>4.1. Оплата заказа осуществляется наличными или безналичным расчетом в течение 24 (двадцати четырех) часов с момента доставки готовой продукции.</li>
          <li>4.2. Полная стоимость заказа включает стоимость продукции и, при необходимости, услуги доставки (если иное не указано в условиях Компании).</li>
        </ul>
        <li><strong>Доставка и передача продукции:</strong></li>
        <ul>
          <li>5.1. Компания осуществляет доставку готовой продукции по указанному Клиентом адресу.</li>
          <li>5.2. Сроки доставки согласовываются при оформлении заказа. Компания оставляет за собой право изменять время доставки в случае форс-мажорных обстоятельств.</li>
          <li>5.3. Бесплатная доставка предоставляется при оформлении заказа на сумму от 12 000 тенге.</li>
          <li>5.4. В случае, если доставка блюда не будет выполнена до 13:00 либо оно будет ненадлежащего качества, при условии своевременного уведомления с вашей стороны, указанное блюдо будет исключено из вашего заказа.</li>
        </ul>
        <li><strong>Качество продукции:</strong></li>
        <ul>
          <li>6.1. Компания гарантирует высокое качество продукции, соответствующее санитарным и гигиеническим нормам.</li>
          <li>6.2. В случае выявления брака или несоответствия заказа Клиент вправе обратиться в Компанию для урегулирования ситуации.</li>
        </ul>
        <li><strong>Возврат и отмена заказа:</strong></li>
        <ul>
          <li>7.1. Клиент вправе отменить заказ до момента его отправки.</li>
          <li>7.2. Возврат денежных средств осуществляется в случае полного отказа от заказа при соблюдении условий Компании.</li>
          <li>7.3. С момента отправления заказа денежные средства возврату не подлежат.</li>
        </ul>
        <li><strong>Ответственность сторон:</strong></li>
        <ul>
          <li>8.1. Компания не несет ответственности за задержку доставки или неполучение заказа по причине предоставления Клиентом некорректных контактных данных.</li>
          <li>8.2. Клиент несет ответственность за оплату заказа и получение продукции в согласованное время.</li>
        </ul>
        <li><strong>Заключительные положения:</strong></li>
        <ul>
          <li>9.1. Настоящая оферта может быть изменена Компанией в одностороннем порядке без предварительного уведомления Клиента путем изменения редакции на сайте.</li>
          <li>9.2. Актуальная редакция оферты размещена на официальном сайте Компании.</li>
        </ul>
      </ul>
      <h6 class="policy-section-title">Политика конфиденциальности</h6>
      <ul class="policy-points">
        <li>Персональные данные используются исключительно для выполнения заказов.</li>
        <li>Данные могут быть использованы для программы лояльности и специальных предложений.</li>
        <li>Обработка данных соответствует Закону РК "О персональных данных и их защите".</li>
        <li>Данные защищены от несанкционированного доступа.</li>
        <li>Передача данных третьим лицам допускается только в случаях, предусмотренных законом.</li>
      </ul>
    </div>
    <div class="policy-requisites">
    <h4 class="requisites-title">Реквизиты компании</h4>
    <table class="requisites-table">
      <tbody>
      <tr>
        <td class="requisites-label">Название:</td>
        <td class="requisites-value">Товарищество с ограниченной ответственностью "Food Republic"</td>
      </tr>
      <tr>
        <td class="requisites-label">ИИН/БИН:</td>
        <td class="requisites-value">180640016042</td>
      </tr>
      <tr>
        <td class="requisites-label">Юр. адрес:</td>
        <td class="requisites-value">Республика Казахстан, г. Алматы, Алмалинский район, улица Толе би, дом 286/4</td>
      </tr>
      <tr>
        <td class="requisites-label">КБе:</td>
        <td class="requisites-value">17</td>
      </tr>
      <tr>
        <td class="requisites-label">Счет:</td>
        <td class="requisites-value">KZ75998CTB0000453419</td>
      </tr>
      <tr>
        <td class="requisites-label">Банк:</td>
        <td class="requisites-value">АО "Jusan Bank"</td>
      </tr>
      <tr>
        <td class="requisites-label">БИК:</td>
        <td class="requisites-value">TSESKZKA</td>
      </tr>
      <tr>
        <td class="requisites-label">Email:</td>
        <td class="requisites-value">
          <a href="mailto:keremet.coffee@gmail.com">{{'keremet.coffee@gmail.com'}}</a>
        </td>
      </tr>
      </tbody>
    </table>
  </div>

    <div class="policy-actions">
      <label class="policy-checkbox">
        <input type="checkbox" [(ngModel)]="isChecked" />
        <span>Я ознакомлен(а) и согласен(на) с условиями оферты и Политикой конфиденциальности</span>
      </label>
      <button class="btn-accept" [disabled]="!isChecked" (click)="acceptPolicy()">Согласен</button>
    </div>
  </div>
</div>
